import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Title/Home";

const Title = () => {
  return (
    <div className="Home">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to={"/"} replace />} />
      </Routes>
    </div>
  );
};

export default Title;
